let rightPoints = document.querySelectorAll('.important_know .right_content .right_cont_abs_items');
let mobileHoverPoints = document.querySelectorAll('.important_know .right_content .hidden_abs_itm.mobile');

function showActivePoint(dataName) {
  if (window.innerWidth < 1025) {
    mobileHoverPoints.forEach(mPoint => {
      mPoint.classList.toggle("show", mPoint.dataset.itemName === dataName);
    });
  }
}

function removeAllActivePoints() {
  if (window.innerWidth < 1025) {
    mobileHoverPoints.forEach(mPoint => {
      mPoint.classList.remove("show");
    });
  }
}

rightPoints.forEach(point => {
  point.addEventListener('click', function (event) {
    event.stopPropagation(); // Prevent triggering the document click
    showActivePoint(point.dataset.itemName);
  });
});

document.addEventListener("click", function (event) {
  // Check if the click target is outside of any .right_cont_abs_items
  if( !(event.target.matches('.right_cont_abs_items') ||
        event.target.matches('.hidden_abs_itm') ||
        event.target.matches('.hidden_abs_itm_txt')
       ) 
    ){
    removeAllActivePoints();
  }
});
